import React from "react";
import { useDispatch } from "react-redux";

import { IgButton } from "@intelligems/ig-theme";
import { ShippingProgressBarWidget } from "@intelligems/ig-types";
import { Grid } from "@mui/material";

import { initializeWidget } from "../../../api/initials";
import { setDrawer } from "../../../store/slices/global";
import { setSelectedWidget } from "../../../store/slices/widgets";
import { mpClickCreateWidgetButton } from "../../../utils/mixpanel";
import { WidgetDrawer } from "../WidgetDrawer/WidgetDrawer";

import { ShippingProgressBarWidgetPreview } from "./ShippingProgressBarWidgetPreview";

interface ShippingProgressBarWidgetsOverviewProps {
  shippingProgressBarWidgets: ShippingProgressBarWidget[];
}
export const ShippingProgressBarWidgetsOverview = ({
  shippingProgressBarWidgets,
}: ShippingProgressBarWidgetsOverviewProps) => {
  const dispatch = useDispatch();

  const onCreateNew = () => {
    mpClickCreateWidgetButton("shippingProgressBar");
    dispatch(
      setSelectedWidget(
        initializeWidget(
          "shippingProgressBar",
          "progressBarWidget1"
        ) as ShippingProgressBarWidget
      )
    );
    dispatch(setDrawer({ drawer: "widgetAction", open: true }));
  };

  return (
    <Grid
      container
      direction={"column"}
      alignItems={"flex-end"}
      rowSpacing={2}
      columnSpacing={2}
    >
      <Grid item>
        <IgButton
          variant={"contained"}
          onClick={() => {
            onCreateNew();
          }}
        >
          Create Shipping Progress Bar
        </IgButton>
      </Grid>
      <Grid item container direction={"row"} rowSpacing={2} columnSpacing={2}>
        {shippingProgressBarWidgets.map((progressBar, index) => (
          <ShippingProgressBarWidgetPreview
            key={`shipping-progress-bar-${index}`}
            progressBarWidget={progressBar}
          />
        ))}
        <WidgetDrawer
          widgetType={"shippingProgressBar"}
          buttonFocus={"shippingProgressBar"}
        />
      </Grid>
    </Grid>
  );
};
